import actions from './actions';

const initState = {
    data: []
};

export default function StationTemperatureReducer(state = initState, action) {
    switch (action.type) {
        case actions.StationTemperature_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
